import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Tenía el chat más muerto del mundo. Con el Protocolo 3C entendí exactamente qué estaba haciendo mal. En la primera semana ya tenía dos salidas coordinadas. No lo podía creer.',
  name: 'Matías R.',
  location: 'Buenos Aires',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/cfe0bb7d-deda-4014-9653-7a4dda36ff6c.jpg'
}, {
  quote: 'Siempre me trababa al momento de invitar. Sentía que nunca era el momento. El tomo de cierre me cambió la cabeza. Ahora sé exactamente cuándo y cómo dar el paso.',
  name: 'Sebastián T.',
  location: 'Córdoba',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/ab5940ea-1964-4ebd-9713-127090523d66.jpg'
}, {
  quote: 'El Kit Anti-Visto solo ya vale todo el precio. Recuperé tres chats que daba por muertos. Y el bono de aperturas me sacó para siempre del "hola, cómo va" genérico.',
  name: 'Lucas F.',
  location: 'Rosario',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/487f9b27-84d1-4b6d-af9f-e0e60192951d.jpg'
}];
export function Testimonials() {
  return <section aria-label="Testimonios" className="bg-ink" data-id="element-153" data-mp="m2yceiy2y3rk">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20 pt-[47px]" data-id="element-154" data-mp="78tvv5gqytzh">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-155" data-mp="c6ljhnacztxv">
          💬 Lo que dicen quienes ya lo aplicaron
        </h2>
        <div className="mt-10 grid w-full grid-cols-1 gap-5 sm:mt-12 md:grid-cols-3 md:gap-6" data-id="element-156" data-mp="zx7sbgs6ti8x">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex min-h-[230px] flex-col rounded-2xl border border-white/10 bg-ink-2 p-6 sm:min-h-[250px]" data-id="element-157" data-mp="14xdh8p72oqnb" data-mpi={i}>
              <div className="flex gap-0.5 text-gold" data-id="element-158" data-mp="1xhqvri8pngqu">
                {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-4 w-4 fill-current" data-id="element-159" data-mp="1sjz5strmm4pa" data-mpi={k} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-white/80" data-id="element-160" data-mp="1ogjbi4314gfr">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-161" data-mp="1jkc2u3j90qu4">
                <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover ring-2 ring-gold/50" data-id="element-162" data-mp="1el7utg828z5d" />
                <div data-id="element-163" data-mp="19qlgb46omqh2">
                  <div className="text-sm font-bold text-white" data-id="element-164" data-mp="14stqcfpllefi">{t.name}</div>
                  <div className="text-xs text-white/50" data-id="element-165" data-mp="10rqb9vfdjmfc">📍 {t.location}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}